import API from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    ['employees:get']: state => state.list,
  },
  mutations: {
    ['employees:set'](state, { data }) {
      state.list = [...data];
    },
  },
  actions: {
    async ['employees:fetch']({ commit }) {
      try {
        const employees = await API.getEmployees();
        commit('employees:set', employees);
      } catch (err) {
        console.error(err);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/employees/index.js